import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
// DraggableSyntheticListeners is the public alias for `SyntheticListenerMap |
// undefined`; the map type itself is only reachable through @dnd-kit's internal
// dist/ path, which is not part of its published API.
import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core';

interface SortableSceneRenderProps {
  attributes: DraggableAttributes;
  listeners: DraggableSyntheticListeners;
  isDragging: boolean;
}

interface SortableSceneProps {
  id: string;
  disabled?: boolean;
  className?: string;
  children: (props: SortableSceneRenderProps) => React.ReactNode;
}

/**
 * Sortable wrapper for a scene row. Owns the draggable row element and hands the
 * drag-handle props to `children` via a render prop, so only the grip handle
 * starts a drag.
 */
export default function SortableScene({ id, disabled, className = '', children }: SortableSceneProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 20 : undefined,
    position: 'relative',
    background: isDragging ? '#faf5ff' : undefined,
  };

  return (
    <div ref={setNodeRef} style={style} className={className}>
      {children({ attributes, listeners, isDragging })}
    </div>
  );
}
